import { MutableRefObject, useCallback } from 'react';
import ReactQuill from 'react-quill';

import { QUILL_FONT_SIZE_WHITELIST } from './quillFontSizeOptions';

export type ReactQuillProps = ReactQuill['props'];
export const QUILL_TOOLBAR_CONTAINER = [
  ['bold', 'italic', 'underline'],
  [{ size: [...QUILL_FONT_SIZE_WHITELIST] }],
  [{ color: [] }, { background: [] }],
  [{ align: '' }, { align: 'center' }, { align: 'right' }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'image'],
  ['clean'],
];
const useQuillEditorModules = (
  quillRef: MutableRefObject<ReactQuill | null> | undefined
): ReactQuillProps['modules'] => {
  const imageHandler = useCallback(() => {
    if (!quillRef || !quillRef.current) {
      return;
    }
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    if (!range) {
      return;
    }
    const value = prompt('Please copy and paste the image url here.');
    if (value) {
      quill.insertEmbed(range.index, 'image', value, 'user');
    }
  }, [quillRef]);

  const modules = {
    toolbar: {
      container: QUILL_TOOLBAR_CONTAINER,
      handlers: {
        image: imageHandler,
      },
    },
  };

  return modules;
};

export default useQuillEditorModules;
